import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { UmbracoHttpClient } from "@e-forsyning/common/http";

import { IForsyning } from "./forsyning.model";

@Injectable({ providedIn: "root" })
export class ForsyningRepository {
    constructor(private readonly http: UmbracoHttpClient) {}

    public hentForsyning(id: number): Observable<IForsyning> {
        return this.http.get(`GetVaerkInfo?id=${id}`).pipe(map((resultat: any) => this.mapToForsyning(resultat)));
    }

    public hentForsyninger(): Observable<IForsyning[]> {
        return this.http.get("GetVaerker").pipe(map((resultat: any) => this.mapTo(resultat)));
    }

    private mapTo(forsyningerUmb: any): IForsyning[] {
        const forsyninger: IForsyning[] = [];
        if (!forsyningerUmb) {
            return forsyninger;
        }

        for (const forsyningUmb of forsyningerUmb) {
            const forsyning = this.mapToForsyning(forsyningUmb);
            forsyninger.push(forsyning);
        }
        return forsyninger.sort((a, b) => (a.navn < b.navn ? -1 : 1));
    }

    private mapToForsyning(forsyningUmb: any): IForsyning {
        return {
            id: forsyningUmb.Id,
            forsyningId: (forsyningUmb.ForsyningId || "").toUpperCase(),
            navn: forsyningUmb.Navn
        };
    }
}
